console.log('%cBuilt by Not selling liquid', 'color:#000; font-weight:bold;');

window.updateCartCountDisplay = function (count) {
  if (typeof count === 'undefined') {
    let countEl = document.querySelector('.cart-count');
    if (countEl) {
      let text = countEl.textContent.trim();
      if (text !== '') {
        count = parseInt(text.replace(/[^0-9]/g, '')) || 0;
      } else {
        return;
      }
    } else {
      return;
    }
  }
  document.querySelectorAll('.cart-count').forEach(function (el) {
    if (window.innerWidth > 991) {
      el.innerHTML = '(' + count + ')';
    } else {
      el.innerHTML = count;
    }
  });
};
window.addEventListener('resize', function () {
  window.updateCartCountDisplay();
});
if (document.querySelectorAll('.variant-grid')) {
  function quickAddButton() {
    document.querySelectorAll('.variant-grid').forEach(function (sizeList) {
      sizeList.addEventListener('click', function (e) {
        e.preventDefault();
        let variant_id = sizeList.dataset.id;
        let error_grid_outer = sizeList.closest('.snippet-product-card');
        let error_grid = error_grid_outer.querySelector('.grid-error');
        let formData = {
          'items': [{
            'id': variant_id,
            'quantity': 1
          }]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status == 422) {
              error_grid.innerHTML = data.description;
              setTimeout(function (e) {
                error_grid.innerHTML = '';
              }, 2000);
            } else {
              if (document.location.href.indexOf('/cart') > -1) {
                window.location.href = "/cart";
              } else {
                if (typeof load_cart == 'function') {
                  load_cart().then(function () {
                    if (typeof openCartDrawer == 'function') openCartDrawer();
                  });
                } else {
                  window.location.href = "/cart";
                }
              }
              const url = '/cart.js';
              fetch(url)
                .then((resp) => resp.json())
                .then(function (data) {
                  if (typeof window.updateCartCountDisplay === 'function') {
                    window.updateCartCountDisplay(data.item_count);
                  } else {
                    document.querySelectorAll('.cart-count').forEach(function (el) {
                      if (window.innerWidth > 991) {
                        el.innerHTML = '(' + data.item_count + ')';
                      } else {
                        el.innerHTML = data.item_count;
                      }
                    });
                  }
                })
                .catch(function (error) {
                  console.log(error);
                })
            }
          })
          .catch((error) => {
            console.error(error);
          });
      });
    });
    //     document.querySelectorAll('.quick-add').forEach(function(quickAdd){
    //       quickAdd.onclick = function(){
    //         document.querySelectorAll('.snippet-product-grid').forEach(function(everyProduct){       
    //           everyProduct.classList.remove('active-quick');
    //         });
    //         let gridimgbox = quickAdd.closest('.snippet-product-grid');      
    //         gridimgbox.classList.add('active-quick');
    //       };
    //     });
  }
  quickAddButton();
}
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search') || document.querySelector('#predictive-search');
    this.input.addEventListener('focus', () => {
      document.body.classList.add('open-suggetion');
    });
    this.input.addEventListener('blur', () => {
      document.body.classList.remove('open-suggetion');
    })
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if (input_length > 0) {
        document.querySelectorAll('.search-Button').forEach(function (SeachButtons) {
          SeachButtons.disabled = false;
        });
      } else {
        document.querySelectorAll('.search-Button').forEach(function (SeachButtons) {
          SeachButtons.disabled = true;
        });
      }
    }, 300).bind(this));
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=6&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        if (this.predictiveSearchResults) {
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();
        }
        if (typeof quickAddButton == 'function') {
          quickAddButton();
        }
        if (document.getElementById('SearchValue')) {
          document.getElementById('SearchValue').value = searchTerm;
        }
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }
  open() {
    if (this.predictiveSearchResults) this.predictiveSearchResults.style.display = 'block';
    const suggestion = document.querySelector('.search-suggetion');
    if (suggestion) suggestion.style.display = "none";
  }
  close() {
    if (this.predictiveSearchResults) this.predictiveSearchResults.style.display = 'none';
    const suggestion = document.querySelector('.search-suggetion');
    if (suggestion) suggestion.style.display = "";
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);

document.querySelectorAll('.mobile-search').forEach(function (searchButton) {
  searchButton.addEventListener('click', function (e) {
    if (document.body.classList.contains('open-menu')) {
      const menuDrawer = document.querySelector('.snippet-menu-drawer');
      if (menuDrawer) {
        menuDrawer.style.height = '';
      }
      document.querySelectorAll('.menu-subcategories').forEach(function (subMenu) {
        subMenu.classList.remove('hover-submenu');
      });
    }
    document.querySelector('body').classList.toggle('open-search');
    document.querySelector('body').classList.remove('open-drawer', 'open-menu', 'open-sort', 'open-filter', 'open-view-drawer');
    document.querySelector(".mobile-serachbox #Search").focus();
  });
});
// play/pause video
(function () {
  'use strict';

  /**
   * Returns the subset of videos from `allVideos` whose wrapping element
   * is currently visible on screen. This handles sections that render two
   * separate <video> elements for desktop (d-none d-lg-block) and mobile
   * (d-lg-none) so that the toggle only drives the one the user can see.
   * Falls back to all videos when none pass the visibility test (e.g.
   * single-video sections that are always visible).
   */
  function getVisibleVideos(allVideos) {
    var visible = Array.from(allVideos).filter(function (v) {
      // A video is "visible" when it and all its ancestors are displayed
      // and its bounding box has non-zero dimensions.
      var rect = v.getBoundingClientRect();
      if (rect.width === 0 && rect.height === 0) return false;
      var el = v;
      while (el && el !== document.body) {
        if (getComputedStyle(el).display === 'none') return false;
        el = el.parentElement;
      }
      return true;
    });
    return visible.length > 0 ? visible : Array.from(allVideos);
  }

  /**
   * Sync the button's is-paused class from the currently-visible video.
   * Using the first visible video as the source of truth avoids conflicting
   * play/pause events when a section has both a desktop and mobile <video>.
   */
  function syncButtonState(btn, allVideos) {
    var active = getVisibleVideos(allVideos);
    var isPaused = active.length > 0 ? active[0].paused : false;
    btn.classList.toggle('is-paused', isPaused);
  }

  function initVideoToggles(container) {
    container = container || document;
    var toggles = container.querySelectorAll('.video-toggle');
    toggles.forEach(function (btn) {
      if (btn.dataset.initialized) return;
      var panel = btn.closest('.media__panel') || btn.parentElement;
      var allVideos = panel ? panel.querySelectorAll('video') : [];
      if (allVideos.length === 0) return;
      btn.dataset.initialized = 'true';

      // Click: play/pause only the currently-visible video(s)
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var active = getVisibleVideos(allVideos);
        var shouldPause = active.some(function (v) { return !v.paused; });
        allVideos.forEach(function (video) {
          // Mirror state across all videos so whichever becomes visible next
          // is already in sync with the user's intent.
          if (shouldPause) {
            video.pause();
          } else {
            video.play().catch(function () { });
          }
        });
      });

      // State sync: each video fires play/pause; re-derive from visible video
      allVideos.forEach(function (video) {
        video.addEventListener('play', function () { syncButtonState(btn, allVideos); });
        video.addEventListener('pause', function () { syncButtonState(btn, allVideos); });
      });

      // Initial state
      syncButtonState(btn, allVideos);
    });
  }

  initVideoToggles();
  document.addEventListener('shopify:section:load', function (e) {
    initVideoToggles(e.target);
    if (typeof initHoverLines === 'function') {
      initHoverLines(e.target);
    }
  });
})();
// readmore / readless
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-read-more]').forEach((wrapper) => {
    const content = wrapper.querySelector('[data-read-more-content]');
    const inner = wrapper.querySelector('.read-more__content-inner');
    const button = wrapper.querySelector('[data-read-more-toggle]');
    const getLines = () =>
      window.innerWidth < 768
        ? +wrapper.dataset.mobileLines || 6
        : +wrapper.dataset.desktopLines || 5;

    const getHeight = () =>
      parseFloat(getComputedStyle(inner).lineHeight) * getLines();

    const init = () => {
      const collapsedHeight = getHeight();
      const fullHeight = inner.scrollHeight;

      wrapper.classList.remove('is-expanded');

      if (fullHeight > collapsedHeight + 5) {
        wrapper.classList.add('is-collapsed');
        button.classList.remove('hidden');
        content.style.height = `${collapsedHeight}px`;
      } else {
        wrapper.classList.remove('is-collapsed');
        button.classList.add('hidden');
        content.style.height = 'auto';
      }
    };
    button.addEventListener('click', () => {
      const expanded = wrapper.classList.toggle('is-expanded');
      content.style.height = expanded
        ? `${inner.scrollHeight}px`
        : `${getHeight()}px`;
    });
    init();
    window.addEventListener('resize', init);
  });
});
document.addEventListener('keydown', function (evt) {
  var isEscape = false;
  if ("key" in evt) {
    isEscape = (evt.key === "Escape" || evt.key === "Esc");
  } else {
    isEscape = (evt.keyCode === 27);
  }
  if (isEscape) {
    // 1. View Preference & Filter Drawers (Collection page)
    if (window.collectionDrawers && typeof window.collectionDrawers.closeAllDrawers === 'function') {
      window.collectionDrawers.closeAllDrawers();
    }
    // 2. Product page Accordion Drawers
    if (window.productDrawers && typeof window.productDrawers.closeAllDrawers === 'function') {
      window.productDrawers.closeAllDrawers();
    }
    // 3. Size Guide Drawer
    if (typeof window.closeSizeGuide === 'function') {
      window.closeSizeGuide();
    }
    // 4. Quick Buy / Quick Shop Drawer
    if (typeof window.closeQuickBuy === 'function') {
      window.closeQuickBuy();
    }
    // 5. Cart Drawer
    if (typeof window.closeCartDrawer === 'function') {
      window.closeCartDrawer();
    }
    // 6. Search Drawer
    if (window.searchDrawerInstance && typeof window.searchDrawerInstance.close === 'function') {
      window.searchDrawerInstance.close();
    }

    // Clean up classes from body just in case
    document.body.classList.remove(
      'open-filter',
      'open-sort',
      'open-drawer',
      'open-menu',
      'open-search',
      'open-quick-buy',
      'open-view-drawer',
      'open-size-guide',
      'open-mc-drawer'
    );
  }
});
class HoverUnderline {
  constructor(element) {
    this.element = element;
    if (this.element.dataset.hoverInitialized) return;
    this.element.dataset.hoverInitialized = 'true';
    this.line = element.querySelector('.hover-line');
    if (!this.line) {
      this.line = document.createElement('span');
      this.line.className = 'hover-line';
      element.appendChild(this.line);
    }
    const line1 = element.querySelector('.hover-line-1');
    if (line1) line1.remove();
    const line2 = element.querySelector('.hover-line-2');
    if (line2) line2.remove();
    this.progress = 0;
    this.target = 0;
    this.origin = 'left';
    this.rafId = null;
    this.startTime = 0;
    this.startProgress = 0;
    this.duration = 600;
    this.triggerElement = this.element;
    const parentTrigger = this.element.closest('.overlay-border-anim, .border-anim');
    if (parentTrigger) {
      this.triggerElement = parentTrigger;
    }
    this.init();
  }
  init() {
    const isMobile = window.matchMedia('(max-width: 991px)').matches;
    if (isMobile) return;
    this.line.style.left = '0%';
    this.line.style.right = 'auto';
    this.line.style.width = '100%';
    this.line.style.transform = 'scaleX(0)';
    this.line.style.transformOrigin = 'left';
    this.triggerElement.addEventListener('mouseenter', () => {
      this.target = 1;
      this.animate();
    }, { passive: true });
    this.triggerElement.addEventListener('mouseleave', () => {
      if (this.triggerElement.classList.contains('mega-menu-hover')) {
        const subMenu = this.triggerElement.querySelector('.menu-subcategories');
        if (subMenu && subMenu.classList.contains('hover-submenu')) {
          return;
        }
      }
      this.target = 0;
      this.animate();
    }, { passive: true });

    if (this.triggerElement.classList.contains('mega-menu-hover')) {
      const subMenu = this.triggerElement.querySelector('.menu-subcategories');
      if (subMenu) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'class') {
              if (!subMenu.classList.contains('hover-submenu')) {
                this.target = 0;
                this.animate();
              } else {
                this.target = 1;
                this.animate();
              }
            }
          });
        });
        observer.observe(subMenu, { attributes: true });
      }
    }
  }
  animate() {
    if (this.rafId) cancelAnimationFrame(this.rafId);
    this.startTime = performance.now();
    this.startProgress = this.progress;
    const solveCubicBezier = (p1x, p1y, p2x, p2y, t) => {
      if (t === 0 || t === 1) return t;
      let u = t;
      for (let i = 0; i < 8; i++) {
        const x = 3 * (1 - u) * (1 - u) * u * p1x + 3 * (1 - u) * u * u * p2x + u * u * u;
        const dx = 3 * (1 - u) * (1 - u) * p1x + 6 * (1 - u) * u * (p2x - p1x) + 3 * u * u * (1 - p2x);
        if (Math.abs(dx) < 1e-6) break;
        u -= (x - t) / dx;
      }
      return 3 * (1 - u) * (1 - u) * u * p1y + 3 * (1 - u) * u * u * p2y + u * u * u;
    };
    const tick = () => {
      const elapsed = performance.now() - this.startTime;
      const t = Math.min(elapsed / this.duration, 1);
      const easedT = solveCubicBezier(0.9, 0, 0.1, 1, t);
      if (this.target === 1) {
        this.progress = this.startProgress + (1 - this.startProgress) * easedT;
      } else {
        this.progress = this.startProgress * (1 - easedT);
      }
      if (this.progress <= 0.001) {
        this.progress = 0;
        this.origin = 'left';
      } else if (this.progress >= 0.999) {
        this.progress = 1;
        this.origin = 'right';
      }
      this.line.style.transformOrigin = this.origin;
      this.line.style.transform = `scaleX(${this.progress})`;

      if (t < 1 && ((this.target === 1 && this.progress < 1) || (this.target === 0 && this.progress > 0))) {
        this.rafId = requestAnimationFrame(tick);
      } else {
        this.rafId = null;
      }
    };
    this.rafId = requestAnimationFrame(tick);
  }
}
function initHoverLines(container = document) {
  const elements = container.querySelectorAll('.link-cta, .border-anim-inr');
  elements.forEach((el) => {
    new HoverUnderline(el);
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initHoverLines());
} else {
  initHoverLines();
}

// ===== WISHLIST STATE MANAGEMENT =====
(function () {
  const WISHLIST_KEY = 'ns_wishlist_data';

  window.getWishlistItems = function () {
    try {
      const dataStr = localStorage.getItem(WISHLIST_KEY);
      if (!dataStr) return [];
      const parsed = JSON.parse(dataStr);
      return parsed?.data?.wishlists?.[0]?.wishlists || [];
    } catch (e) {
      console.error('Error reading wishlist from localStorage:', e);
      return [];
    }
  };

  window.setWishlistItems = function (items) {
    try {
      const structure = {
        "data": {
          "wishlists": [
            {
              "wishlists": items
            }
          ]
        }
      };
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(structure));
      window.updateWishlistUI();
      // Dispatch custom event for dynamic updates on wishlist page
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items } }));
    } catch (e) {
      console.error('Error saving wishlist to localStorage:', e);
    }
  };

  window.toggleWishlistItem = function (item) {
    let items = window.getWishlistItems();
    const index = items.findIndex(it => String(it.handle) === String(item.handle));
    if (index > -1) {
      // Remove it
      items.splice(index, 1);
      window.setWishlistItems(items);
    } else {
      // Add it
      items.push({
        product_id: String(item.product_id),
        variant_id: String(item.variant_id),
        handle: String(item.handle)
      });
      window.setWishlistItems(items);
    }
  };

  window.updateWishlistUI = function () {
    const items = window.getWishlistItems();
    const handles = items.map(it => String(it.handle));

    // Toggle active class on all wishlist buttons
    document.querySelectorAll('.wishlist-btn').forEach(btn => {
      const handle = btn.getAttribute('data-handle');
      if (handle && handles.includes(String(handle))) {
        btn.classList.add('active');
        btn.setAttribute('data-wishlist-added', 'true');
      } else {
        btn.classList.remove('active');
        btn.removeAttribute('data-wishlist-added');
      }
    });

    // Update global wishlist counters if present
    document.querySelectorAll('.wishlist-count').forEach(el => {
      el.textContent = items.length;
    });
  };

  // Bind click listeners on document load
  function initWishlistListeners() {
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.wishlist-btn');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      const handle = btn.getAttribute('data-handle');
      const productId = btn.getAttribute('data-product-id');
      const variantId = btn.getAttribute('data-variant-id');

      if (!handle) return;

      window.toggleWishlistItem({
        product_id: productId || '',
        variant_id: variantId || '',
        handle: handle
      });
    });

    // Initial UI update
    window.updateWishlistUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistListeners);
  } else {
    initWishlistListeners();
  }

  // Hook for when new sections are dynamically loaded (e.g. Quick Buy popup)
  document.addEventListener('shopify:section:load', function () {
    window.updateWishlistUI();
  });

  // Also hook into custom quick buy open using MutationObserver
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.target.classList.contains('active')) {
        window.updateWishlistUI();
      }
    });
  });
  const quickBuyPopup = document.querySelector('.snippet-quick-buy-popup');
  if (quickBuyPopup) {
    observer.observe(quickBuyPopup, { attributes: true, attributeFilter: ['class'] });
  }
})();

// ===== GLOBAL SIZE GUIDE DRAWER EVENT DELEGATION =====
(function () {
  'use strict';

  let _activeDrawer = null; // tracks the currently open drawer element
  let prevFocusedElement = null;
  let sizeGuideTimeout = null;

  function openSizeGuide(drawer) {
    if (!drawer) return;
    if (sizeGuideTimeout) {
      clearTimeout(sizeGuideTimeout);
      sizeGuideTimeout = null;
    }
    // Close any previously open drawer first
    if (_activeDrawer && _activeDrawer !== drawer) {
      _activeDrawer.classList.remove('is-open');
      _activeDrawer.setAttribute('aria-hidden', 'true');
    }

    // If the drawer is nested inside a stacking-context parent (e.g. the quick-buy
    // popup which has position:fixed z-index:101), its own z-index:99999 is scoped
    // inside that parent's level and it can't paint above the popup.
    // Moving the drawer to <body> makes its z-index global, so it appears on top.
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    // Force a synchronous browser reflow so the initial transform:translateX(100%)
    // state is committed before we add is-open.  Without this the browser may skip
    // the starting frame and the slide-in transition doesn't fire (drawer appears
    // instantly on first click and after DOM moves).
    void drawer.offsetHeight;

    _activeDrawer = drawer;
    prevFocusedElement = document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    document.body.classList.add('open-size-guide');
    drawer.focus();
  }

  function closeSizeGuide() {
    const drawer = _activeDrawer || document.querySelector('.size-guide-drawer.is-open');
    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }
    _activeDrawer = null;
    if (sizeGuideTimeout) clearTimeout(sizeGuideTimeout);
    sizeGuideTimeout = setTimeout(() => {
      document.body.classList.remove('open-size-guide');
    }, 10);
    if (prevFocusedElement && prevFocusedElement.focus) {
      prevFocusedElement.focus();
    }
  }

  window.closeSizeGuide = closeSizeGuide;

  // 1. Delegated click on .size-guide-link to open the correct drawer
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.size-guide-link');
    if (!trigger) return;
    e.preventDefault();
    // Walk up to the nearest <section> so we find the drawer rendered in the
    // same section as the link (quick-buy popup has its own, product page has its own).
    const section = trigger.closest('section') || document;
    const drawer = section.querySelector('.size-guide-drawer') || document.querySelector('.size-guide-drawer');
    openSizeGuide(drawer);
  });

  // 2. Delegated click on close button inside drawer — close only that drawer
  document.addEventListener('click', function (e) {
    const closeBtn = e.target.closest('.size-guide-drawer__close-btn');
    if (closeBtn) {
      e.preventDefault();
      closeSizeGuide();
    }
  });

  // 3. Delegated click on overlay-box to close drawer
  document.addEventListener('click', function (e) {
    if (e.target.closest('.overlay-box')) {
      if (document.body.classList.contains('open-size-guide')) {
        closeSizeGuide();
      }
    }
  }, true);

  // 4. Escape key press to close drawer
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('open-size-guide')) {
      closeSizeGuide();
    }
  });

  // 5. Scroll behavior inside drawer (use capture phase as scroll does not bubble)
  document.addEventListener('scroll', function (e) {
    if (!e.target || typeof e.target.closest !== 'function') return;
    const contentEl = e.target.closest('.size-guide-drawer__content');
    if (contentEl) {
      const drawer = contentEl.closest('.size-guide-drawer');
      if (drawer) {
        if (contentEl.scrollTop > 0) {
          drawer.classList.add('is-scrolled');
        } else {
          drawer.classList.remove('is-scrolled');
        }
      }
    }
  }, true);
  // Helper function to highlight row/column cells in table
  function highlightCell(targetCell, table) {
    table.querySelectorAll('td, th').forEach(cell => {
      cell.classList.remove('highlight-dark', 'highlight-soft');
    });
    if (!targetCell || (targetCell.tagName !== 'TD' && targetCell.tagName !== 'TH')) return;

    const colIndex = targetCell.cellIndex;
    const row = targetCell.closest('tr');
    const rows = table.querySelectorAll('tr');

    // Highlight entire row
    row.querySelectorAll('td, th').forEach(c => {
      c.classList.add('highlight-soft');
    });

    // Highlight entire column
    rows.forEach(r => {
      const c = r.cells[colIndex];
      if (c) {
        c.classList.add('highlight-soft');
      }
    });

    // Highlight exact target cell with a darker background
    targetCell.classList.remove('highlight-soft');
    targetCell.classList.add('highlight-dark');
  }

  // 6. Desktop table cell hover behavior
  document.addEventListener('mouseover', function (e) {
    if (window.innerWidth > 767) {
      const cell = e.target.closest('.size-guide-drawer__table-wrapper table td, .size-guide-drawer__table-wrapper table th');
      if (cell) {
        const table = cell.closest('table');
        if (table) {
          highlightCell(cell, table);
        }
      }
    }
  });

  document.addEventListener('mouseout', function (e) {
    if (window.innerWidth > 767) {
      const cell = e.target.closest('.size-guide-drawer__table-wrapper table td, .size-guide-drawer__table-wrapper table th');
      if (cell) {
        const table = cell.closest('table');
        if (table) {
          table.querySelectorAll('td, th').forEach(c => c.classList.remove('highlight-dark', 'highlight-soft'));
        }
      }
    }
  });

  // 7. Mobile table cell click-toggle behavior
  document.addEventListener('click', function (e) {
    if (window.innerWidth <= 767) {
      const cell = e.target.closest('.size-guide-drawer__table-wrapper table td, .size-guide-drawer__table-wrapper table th');
      if (cell) {
        const table = cell.closest('table');
        if (table) {
          if (cell.classList.contains('highlight-dark')) {
            table.querySelectorAll('td, th').forEach(c => c.classList.remove('highlight-dark', 'highlight-soft'));
          } else {
            highlightCell(cell, table);
          }
        }
      }
    }
  });

  // Helper to transition the color name text smoothly
  function changeColorName(nameEl, newText) {
    if (nameEl.getAttribute('data-target-text') === newText) return;
    nameEl.setAttribute('data-target-text', newText);

    if (nameEl.style.transition.indexOf('opacity') === -1) {
      nameEl.style.transition = 'opacity 0.12s ease-in-out';
    }

    nameEl.style.opacity = '0';

    if (nameEl.colorTransitionTimeout) {
      clearTimeout(nameEl.colorTransitionTimeout);
    }

    nameEl.colorTransitionTimeout = setTimeout(() => {
      nameEl.textContent = newText;
      nameEl.style.opacity = '1';
      nameEl.colorTransitionTimeout = null;
    }, 120);
  }

  // 8. Color swatch hover interaction to dynamically update displayed color name
  document.addEventListener('mouseover', function (e) {
    const swatch = e.target.closest('.product-color-swatch, .pqb-color-swatch');
    if (swatch) {
      const detailsContainer = swatch.closest('.product-color-swatches-details, .pqb-color-swatches-details');
      if (detailsContainer) {
        const nameEl = detailsContainer.querySelector('.js-color-swatch-name');
        if (nameEl) {
          const hoverColor = swatch.getAttribute('data-color-name') || '';
          changeColorName(nameEl, hoverColor);
        }
      }
    }
  });

  document.addEventListener('mouseout', function (e) {
    const swatch = e.target.closest('.product-color-swatch, .pqb-color-swatch');
    if (swatch) {
      const detailsContainer = swatch.closest('.product-color-swatches-details, .pqb-color-swatches-details');
      if (detailsContainer) {
        const nameEl = detailsContainer.querySelector('.js-color-swatch-name');
        if (nameEl) {
          const defaultColor = detailsContainer.getAttribute('data-default-color') || '';
          changeColorName(nameEl, defaultColor);
        }
      }
    }
  });
})();
(function () {
  function setStickyOffset(wrapper) {
    var viewport = window.innerHeight;
    var offset = wrapper.offsetHeight - viewport;
    wrapper.style.top = (offset > 0 ? -offset : 0) + 'px';
  }
  function initStickyHero() {
    var wrappers = document.querySelectorAll('.shopify-section.sticky-scroll-hero');
    if (!wrappers.length) return;
    wrappers.forEach(function (wrapper) {
      setStickyOffset(wrapper);
      if (window.ResizeObserver) {
        new ResizeObserver(function () {
          setStickyOffset(wrapper);
        }).observe(wrapper);
      } else {
        wrapper.querySelectorAll('img').forEach(function (img) {
          if (!img.complete) {
            img.addEventListener('load', function () { setStickyOffset(wrapper); }, { once: true });
          }
        });
        wrapper.querySelectorAll('video').forEach(function (video) {
          video.addEventListener('loadedmetadata', function () { setStickyOffset(wrapper); }, { once: true });
        });
      }
    });
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        wrappers.forEach(setStickyOffset);
      }, 150);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyHero);
  } else {
    initStickyHero();
  }
  document.addEventListener('shopify:section:load', initStickyHero);
})();

/* ── Product Grid Color Swatch Hover Image Swap ── */
(function () {
  function handleSwatchHover(e) {
    const swatch = e.target.closest('.pdp-active-color a[data-model-image], .grid-meta-color a[data-model-image]');
    if (!swatch) return;

    const card = swatch.closest('.snippet-product-card');
    if (!card) return;

    const viewContainer = swatch.closest('[data-view]');
    const view = viewContainer ? (viewContainer.getAttribute('data-view') || 'model') : 'model';

    const pxImg = card.querySelector('.px-image');
    const mxImg = card.querySelector('.mx-image');
    const staticImg = card.querySelector('.static-image');

    const swatchModelImg = swatch.getAttribute('data-model-image');
    const swatchProductImg = swatch.getAttribute('data-product-image');

    if (e.type === 'mouseover') {
      if (pxImg) {
        if (!pxImg.dataset.originalSrc) {
          pxImg.dataset.originalSrc = pxImg.getAttribute('src') || '';
          pxImg.dataset.originalSrcset = pxImg.getAttribute('srcset') || '';
        }
        if (swatchModelImg) {
          pxImg.src = swatchModelImg;
          pxImg.removeAttribute('srcset');
        }
      }

      if (mxImg) {
        if (!mxImg.dataset.originalSrc) {
          mxImg.dataset.originalSrc = mxImg.getAttribute('src') || '';
          mxImg.dataset.originalSrcset = mxImg.getAttribute('srcset') || '';
        }
        if (swatchProductImg) {
          mxImg.src = swatchProductImg;
          mxImg.removeAttribute('srcset');
        }
      }

      if (staticImg) {
        if (!staticImg.dataset.originalSrc) {
          staticImg.dataset.originalSrc = staticImg.getAttribute('src') || '';
          staticImg.dataset.originalSrcset = staticImg.getAttribute('srcset') || '';
        }
        const targetImg = view === 'product' ? swatchProductImg : swatchModelImg;
        if (targetImg) {
          staticImg.src = targetImg;
          staticImg.removeAttribute('srcset');
        }
      }
    } else if (e.type === 'mouseout') {
      if (pxImg && pxImg.dataset.originalSrc) {
        pxImg.src = pxImg.dataset.originalSrc;
        if (pxImg.dataset.originalSrcset) {
          pxImg.setAttribute('srcset', pxImg.dataset.originalSrcset);
        } else {
          pxImg.removeAttribute('srcset');
        }
        pxImg.removeAttribute('data-original-src');
        pxImg.removeAttribute('data-original-srcset');
      }

      if (mxImg && mxImg.dataset.originalSrc) {
        mxImg.src = mxImg.dataset.originalSrc;
        if (mxImg.dataset.originalSrcset) {
          mxImg.setAttribute('srcset', mxImg.dataset.originalSrcset);
        } else {
          mxImg.removeAttribute('srcset');
        }
        mxImg.removeAttribute('data-original-src');
        mxImg.removeAttribute('data-original-srcset');
      }

      if (staticImg && staticImg.dataset.originalSrc) {
        staticImg.src = staticImg.dataset.originalSrc;
        if (staticImg.dataset.originalSrcset) {
          staticImg.setAttribute('srcset', staticImg.dataset.originalSrcset);
        } else {
          staticImg.removeAttribute('srcset');
        }
        staticImg.removeAttribute('data-original-src');
        staticImg.removeAttribute('data-original-srcset');
      }
    }
  }

  document.addEventListener('mouseover', handleSwatchHover);
  document.addEventListener('mouseout', handleSwatchHover);
})();
(function () {
  const targetSelector = '._appEmbed_3eyaa_1';
  const styleContent = ' ._gridItem_1q1d2_172._imageLoading_1q1d2_241{display:none!important} newsletter_app ._formFieldset_cit2d_82 div:empty{display:none!important}  [class*="_formInputField_"],  input._formInputField_nag3b_7 {border:none!important; border-bottom:1px solid var(--primary-black) !important; border-radius:0!important; background:transparent!important; font-family:var(--tk-aktiv-grotesk)!important; padding: 20px 0 8px 8px !important; font-size: 12px !important; color: var(--primary-black) !important; box-shadow: none !important; transition: border-color var(--transition-base, 0.3s ease-in-out) !important;}  [class*="_formInputField_"]:focus,  input._formInputField_nag3b_7:focus {border-bottom: 1px solid var(--primary-black) !important; outline: none !important; box-shadow: none !important;}  label[class*="_formInputFieldLabel_"],  label._formInputFieldLabel_1mxsl_38 {font-family: var(--tk-aktiv-grotesk) !important; color: var(--secondary-dark-grey) !important; font-size: 12px !important; font-weight: 400 !important; line-height: normal !important; left: 8px !important; top: 18px !important; transition: all 0.2s ease-in-out !important; pointer-events: none !important;}  [class*="_formFieldContainer_"]:focus-within label[class*="_formInputFieldLabel_"], ._formFieldContainer_1mxsl_5:focus-within label._formInputFieldLabel_1mxsl_38, [class*="_formInputField_"]:not(:placeholder-shown) ~ label[class*="_formInputFieldLabel_"], [class*="_formInputField_"]:focus ~ label[class*="_formInputFieldLabel_"], input._formInputField_nag3b_7:not(:placeholder-shown) ~ label._formInputFieldLabel_1mxsl_38, input._formInputField_nag3b_7:focus ~ label._formInputFieldLabel_1mxsl_38 {font-size: 10px !important; color: var(--primary-black) !important; top: 10px !important; padding-bottom: 4px; font-weight: 500 !important;} [class*="error"], [class*="Error"], [class*="_formError_"], [class*="_errorBody_"] {color: var(--tertiary-error) !important; font-family: var(--tk-aktiv-grotesk) !important; font-size: 10px !important; font-weight: 400 !important; line-height: 160% !important; margin: 4px 0 0 8px !important; text-align: left !important; display: block !important;} .ns-default-subscribe-trigger-btn, button[class*="_formSubmitButton_"] {display: flex !important; align-items: center !important; justify-content: center !important; margin-top: 12px !important; margin-bottom: 40px !important; width: 100% !important; height: 35px !important; line-height: var(--line-height-160, 1.6) !important; padding: 7px 15px !important; border-radius: var(--radius, 1px) !important; font-family: var(--tk-aktiv-grotesk) !important; font-size: 12px !important; font-weight: 500 !important; text-align: center !important; text-transform: uppercase !important; background-color: transparent !important; color: var(--primary-black, #000) !important; border: 1px solid var(--primary-black, #000) !important; cursor: pointer !important; transition: background-color var(--transition-base, 0.3s ease-in-out), color var(--transition-base, 0.3s ease-in-out), border-color var(--transition-base, 0.3s ease-in-out), opacity var(--transition-base, 0.3s ease-in-out) !important; box-sizing: border-box !important;} .ns-default-subscribe-trigger-btn:hover, button[class*="_formSubmitButton_"]:not(:disabled):not([disabled]):not(.disabled):hover {background-color: var(--primary-black, #000) !important; color: var(--primary-white, #fff) !important; border-color: var(--primary-black, #000) !important;} button[class*="_formSubmitButton_"]:disabled, button[class*="_formSubmitButton_"][disabled], button[class*="_formSubmitButton_"].disabled {background-color: transparent !important; color: var(--secondary-medium-grey) !important; margin-bottom: 0 !important; border: 1px solid var(--secondary-dark-beige) !important; border-color: var(--secondary-dark-beige) !important; cursor: not-allowed !important; pointer-events: none !important; transition: background-color var(--transition-base, 0.3s ease-in-out), color var(--transition-base, 0.3s ease-in-out), border-color var(--transition-base, 0.3s ease-in-out), opacity var(--transition-base, 0.3s ease-in-out) !important;}  button[class*="_formSubmitButton_"]:not(:disabled):not([disabled]):not(.disabled) {background-color: transparent !important; color: var(--primary-black) !important; border: 1px solid var(--primary-black) !important; border-color: var(--primary-black) !important; cursor: pointer !important; pointer-events: auto !important; transition: background-color var(--transition-base, 0.3s ease-in-out), color var(--transition-base, 0.3s ease-in-out), border-color var(--transition-base, 0.3s ease-in-out), opacity var(--transition-base, 0.3s ease-in-out) !important;} ._textBody_2aowh_10 p {text-align: left;}  h2._textHeading_2aowh_35{margin: 0;}  ._formHeader_cit2d_24{margin: 0 0 24px;}  ._formContainer_1q1d2_30{margin:0;border-radius: 0 !important;}._grid_1q1d2_148._left_1q1d2_195 ._gridItem_1q1d2_172:nth-child(1){border-radius: 0 !important;} div._withError_1mxsl_17 > input{width: 100%;}  form._formFieldset_cit2d_82{gap:0 !important; transition: height 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 0.3s ease !important;}._inline_1q1d2_47 ._gridItemContent_1q1d2_257{padding:0 !important;}._gridItemContent_1q1d2_257{padding: 12px !important;} div._formDisclaimer_cit2d_38{display: none !important;}._inline_1q1d2_47 ._formBannerContainer_z5ku3_1 ._formBannerHeading_z5ku3_9{display: none;}._formBannerContainer_z5ku3_1 ._textBody_2aowh_10,._formHeader_jnbzb_24 ._textBody_2aowh_10{color: var(--primary-black, #000);font-family: var(--tk-aktiv-grotesk);font-size: 12px;font-style: normal;font-weight: 400;line-height: 160%;}._inline_1q1d2_47 ._formBannerContainer_z5ku3_1{margin:0;}._inline_1q1d2_47 ._formContainer_1q1d2_30{margin:0;}._inline_1q1d2_47 ._formContainer_1q1d2_30._tight_1q1d2_271{margin:0;} section._formHeader_jnbzb_24 {margin-top: 0 !important;margin-bottom: 12px !important;}._inline_1q1d2_47 .ns-email-warning-text,._gridItem_1q1d2_172 .ns-email-warning-text{margin-top:0 !important;}div._formDisclaimer_jnbzb_38{display: none}._formHeader_jnbzb_24 h2._textHeading_2aowh_35{margin: 0 0 14px;text-align: left;color: var(--primary-black, #000);font-family: var(--tk-aktiv-grotesk-ex-hair);font-size: 12px;font-style: normal;font-weight: 400;line-height: 160%;letter-spacing: -0.24px;text-transform: uppercase;}._grid_1q1d2_148._left_1q1d2_195 ._formContainerCloseButtonPosition_1q1d2_282, ._grid_1q1d2_148._right_1q1d2_204 ._formContainerCloseButtonPosition_1q1d2_282{top: 8px !important;}._formCloseButton_1684x_4._withBackground_1684x_15{width: 24px !important; height: 24px !important;}._formCloseButton_1684x_4 > svg, ._formCloseButton_1684x_4._withBackground_1684x_15 > svg{height: 9px;width: 9px;}._formContainerCloseButtonPosition_1q1d2_282{top: 15px !important;right: 12px !important;}';

  // Context-specific style slots. Each newsletter shadow root gets styleContent
  // (shared base) plus exactly one of these, so footer and popup can be styled
  // independently without changes to one bleeding into the other.
  const footerStyleContent = '';
  const popupStyleContent = '.ns-newsletter-popup form[class*="_formFieldset_"], .ns-newsletter-popup [class*="_formFieldset_"] {display: flex !important; flex-direction: column !important;} .ns-newsletter-popup .ns-default-subscribe-trigger-btn {display: none !important;}';

  // The footer app block renders inside .newsletter_app / <footer>; the popup
  // embed is injected at body level, so anything outside the footer is the popup.
  function isFooterShadowRoot(shadowRoot) {
    const host = shadowRoot.host;
    return !!(host && host.closest && host.closest('.newsletter_app, .section-footer, footer'));
  }

  function isValidEmail(email) {
    const trimmed = email.trim().toLowerCase();

    // Step 1: Validate general format
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
      return false;
    }

    // Step 2: Validate TLD against a list of valid TLDs
    const parts = trimmed.split('.');
    const tld = parts[parts.length - 1];

    const validTlds = [
      'com', 'net', 'org', 'co', 'nl', 'de', 'uk', 'fr', 'be', 'eu', 'us',
      'ca', 'dk', 'se', 'no', 'ch', 'at', 'it', 'es', 'pl', 'ie', 'fi',
      'lu', 'io', 'info', 'biz', 'edu', 'gov', 'ru', 'au', 'nz', 'in',
      'jp', 'cn', 'sg', 'hk', 'tw', 'kr', 'za', 'br', 'mx', 'ar', 'cl',
      'cc', 'tv', 'me', 'app', 'shop', 'store', 'online', 'club', 'site',
      'website', 'tech', 'space', 'studio', 'design', 'group', 'company',
      'media', 'digital', 'world', 'life', 'love', 'email', 'support'
    ];

    return validTlds.indexOf(tld) !== -1;
  }

  function handleShadowRoot(shadowRoot) {
    if (!shadowRoot) return;
    try {
      const appEl = shadowRoot.querySelector(targetSelector);
      if (!appEl) return;

      const isFooter = isFooterShadowRoot(shadowRoot);
      appEl.classList.add(isFooter ? 'ns-newsletter-footer' : 'ns-newsletter-popup');

      // 1. Inject Styles (shared base + context-specific slot)
      if (!shadowRoot._formStyleInjected) {
        const s = document.createElement('style');
        s.setAttribute('data-theme', 'forms-override');
        s.textContent = styleContent + (isFooter ? footerStyleContent : popupStyleContent);
        shadowRoot.appendChild(s);
        shadowRoot._formStyleInjected = true;
      }

      // 2. Inject Validation Logic
      if (!shadowRoot._formLogicInjected) {
        setupFormValidation(shadowRoot, isFooter);
      }
    } catch (e) { }
  }

  function setupFormValidation(shadowRoot, isFooter) {
    shadowRoot._formLogicInjected = true;
    let observer;

    function getFields() {
      const emailInput = shadowRoot.querySelector('#email, input[type="email"], input[name="email"], input[class*="_formInputField_"]');
      const firstInput = shadowRoot.querySelector('#first_name, input[name="first_name"]');
      const lastInput = shadowRoot.querySelector('#last_name, input[name="last_name"]');
      const submitBtn = shadowRoot.querySelector('button[data-testid="btn-form-submit"], button[class*="_formSubmitButton_"]');
      return { emailInput, firstInput, lastInput, submitBtn };
    }

    // Default state trigger button setup (footer only — the popup must show its
    // input fields immediately on landing)
    function setupDefaultAccordionState() {
      if (!isFooter) return;
      const formFieldset = shadowRoot.querySelector('form[class*="_formFieldset_"], [class*="_formFieldset_"]');
      if (!formFieldset) return;

      let defaultBtn = shadowRoot.querySelector('.ns-default-subscribe-trigger-btn');
      if (!defaultBtn) {
        defaultBtn = document.createElement('button');
        defaultBtn.type = 'button';
        defaultBtn.className = 'cta-btn cta-btn--secondary cta-btn--light ns-default-subscribe-trigger-btn';
        defaultBtn.textContent = 'Subscribe';

        // Hide form fields initially and place default Subscribe button
        formFieldset.style.display = 'none';
        formFieldset.insertAdjacentElement('beforebegin', defaultBtn);

        defaultBtn.addEventListener('click', () => {
          defaultBtn.style.setProperty('display', 'none', 'important');
          formFieldset.style.display = 'flex';
          formFieldset.style.flexDirection = 'column';

          const scrollToFooterBottom = () => {
            const footer = document.querySelector('footer');
            const footerContent = document.querySelector('.footer__content');
            if (footer && footerContent) {
              footer.style.minHeight = footerContent.offsetHeight + 'px';
            }
            window.scrollTo({
              top: Math.max(document.body.scrollHeight, document.documentElement.scrollHeight),
              behavior: 'smooth'
            });
          };

          scrollToFooterBottom();
          requestAnimationFrame(scrollToFooterBottom);
          setTimeout(scrollToFooterBottom, 150);
          setTimeout(scrollToFooterBottom, 350);

          const { emailInput } = getFields();
          if (emailInput) {
            try {
              emailInput.focus({ preventScroll: true });
            } catch (e) {
              emailInput.focus();
            }
          }
        });
      }
    }

    // Direct helper to determine current validity check
    function isFormValid() {
      const { emailInput, firstInput, lastInput } = getFields();
      const emailVal = emailInput ? emailInput.value.trim() : '';
      const firstVal = firstInput ? firstInput.value.trim() : '';
      const lastVal = lastInput ? lastInput.value.trim() : '';

      const emailValid = emailVal.length > 0 && isValidEmail(emailVal);
      const firstValid = !firstInput || firstVal.length > 0;
      const lastValid = !lastInput || lastVal.length > 0;

      return emailValid && firstValid && lastValid;
    }

    function getOrCreateError(input, key) {
      if (!input) return null;
      const fieldKey = key || input.id || input.name || 'field';
      const container = input.parentElement;
      if (!container) return null;

      const parent = container.parentElement || shadowRoot;
      const existing = parent.querySelectorAll(`.ns-field-warning-text[data-for="${fieldKey}"]`);

      if (existing.length > 1) {
        for (let i = 1; i < existing.length; i++) {
          existing[i].remove();
        }
      }

      let err = existing[0] || null;
      if (!err) {
        err = document.createElement('div');
        err.className = 'ns-field-warning-text ns-email-warning-text';
        err.setAttribute('data-for', fieldKey);
        err.style.cssText = 'color:var(--tertiary-error,#d00);font-size:10px;font-weight:400;margin:4px 0 0 8px;display:none;font-family:var(--tk-aktiv-grotesk,sans-serif);line-height:160%;';
        container.insertAdjacentElement('afterend', err);
      }
      return err;
    }

    // Popup safety net: undo any hidden fieldset / stray trigger button so the
    // inputs are always visible when the popup appears.
    function ensurePopupFieldsVisible() {
      if (isFooter) return;
      const formFieldset = shadowRoot.querySelector('form[class*="_formFieldset_"], [class*="_formFieldset_"]');
      if (formFieldset && formFieldset.style.display === 'none') {
        formFieldset.style.display = 'flex';
        formFieldset.style.flexDirection = 'column';
      }
      const strayBtn = shadowRoot.querySelector('.ns-default-subscribe-trigger-btn');
      if (strayBtn) strayBtn.remove();
    }

    function updateState() {
      setupDefaultAccordionState();
      ensurePopupFieldsVisible();

      const { emailInput, firstInput, lastInput, submitBtn } = getFields();

      if (emailInput && !emailInput.hasAttribute('required')) emailInput.setAttribute('required', '');
      if (firstInput && !firstInput.hasAttribute('required')) firstInput.setAttribute('required', '');
      if (lastInput && !lastInput.hasAttribute('required')) lastInput.setAttribute('required', '');

      function addAsteriskToLabel(input) {
        if (!input) return;
        let label = shadowRoot.querySelector(`label[for="${input.id}"]`);
        if (!label && input.parentElement) {
          label = input.parentElement.querySelector('label');
        }
        if (label) {
          const text = label.textContent.trim();
          if (!text.endsWith('*') && !label.querySelector('.ns-required-asterisk')) {
            const asterisk = document.createElement('span');
            asterisk.className = 'ns-required-asterisk';
            asterisk.textContent = '*';
            label.appendChild(asterisk);
          }
        }
      }

      if (emailInput) addAsteriskToLabel(emailInput);
      if (firstInput) addAsteriskToLabel(firstInput);
      if (lastInput) addAsteriskToLabel(lastInput);

      const emailVal = emailInput ? emailInput.value.trim() : '';
      const firstVal = firstInput ? firstInput.value.trim() : '';
      const lastVal = lastInput ? lastInput.value.trim() : '';

      const emailFilled = emailVal.length > 0;
      const emailValid = isValidEmail(emailVal);

      if (!submitBtn) return;

      const firstValid = !firstInput || firstVal.length > 0;
      const lastValid = !lastInput || lastVal.length > 0;

      const shouldDisable = !(emailFilled && emailValid && firstValid && lastValid);

      if (submitBtn.disabled !== shouldDisable) {
        if (observer) observer.disconnect();
        submitBtn.disabled = shouldDisable;
        if (observer) {
          observer.observe(shadowRoot, {
            attributes: true,
            subtree: true,
            attributeFilter: ['disabled']
          });
        }
      }

      if (emailInput) {
        const err = getOrCreateError(emailInput, 'email');
        if (err) {
          if (!emailFilled) {
            if (emailInput._wasBlurred || emailInput._showError) {
              err.textContent = 'This is a mandatory field.';
              err.style.display = 'block';
            } else {
              err.style.display = 'none';
            }
          } else if (!emailValid) {
            err.textContent = 'Your email address is incorrect. Try again.';
            err.style.display = 'block';
          } else {
            err.style.display = 'none';
          }
        }
      }

      if (firstInput) {
        const val = firstInput.value.trim();
        const err = getOrCreateError(firstInput, 'first_name');
        if (err) {
          if (val === '' && (firstInput._wasBlurred || firstInput._showError)) {
            err.textContent = 'This is a mandatory field.';
            err.style.display = 'block';
          } else {
            err.style.display = 'none';
          }
        }
      }

      if (lastInput) {
        const val = lastInput.value.trim();
        const err = getOrCreateError(lastInput, 'last_name');
        if (err) {
          if (val === '' && (lastInput._wasBlurred || lastInput._showError)) {
            err.textContent = 'This is a mandatory field.';
            err.style.display = 'block';
          } else {
            err.style.display = 'none';
          }
        }
      }
    }

    // Listen on shadowRoot using event delegation
    shadowRoot.addEventListener('input', (e) => {
      if (e.target && e.target.tagName === 'INPUT') {
        updateState();
      }
    });

    shadowRoot.addEventListener('change', (e) => {
      if (e.target && e.target.tagName === 'INPUT') {
        updateState();
      }
    });

    shadowRoot.addEventListener('focusout', (e) => {
      if (e.target && e.target.tagName === 'INPUT') {
        e.target._wasBlurred = true;
        updateState();
      }
    });

    shadowRoot.addEventListener('click', (e) => {
      const btn = e.target.closest('button[data-testid="btn-form-submit"], button[class*="_formSubmitButton_"]');
      if (btn) {
        const { emailInput, firstInput, lastInput } = getFields();
        [emailInput, firstInput, lastInput].forEach((inp) => { if (inp) inp._showError = true; });
        if (!isFormValid()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          updateState();
        }
      }
    }, true);

    shadowRoot.addEventListener('submit', (e) => {
      const { emailInput, firstInput, lastInput } = getFields();
      [emailInput, firstInput, lastInput].forEach((inp) => { if (inp) inp._showError = true; });
      if (!isFormValid()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        updateState();
      }
    }, true);

    // Observe changes inside the shadowRoot (disabled attribute changes only)
    observer = new MutationObserver(() => {
      updateState();
    });
    observer.observe(shadowRoot, {
      attributes: true,
      subtree: true,
      attributeFilter: ['disabled']
    });

    // Success observer to watch for form transition to success state
    const successObserver = new MutationObserver(() => {
      const emailInput = shadowRoot.querySelector('#email');
      if (!emailInput) {
        const defaultBtn = shadowRoot.querySelector('.ns-default-subscribe-trigger-btn');
        if (defaultBtn) defaultBtn.style.display = 'none';

        const bodyEl = shadowRoot.querySelector('[class*="_textBody_"] p') ||
          shadowRoot.querySelector('[class*="_textBody_"]') ||
          shadowRoot.querySelector('form p') ||
          shadowRoot.querySelector('p');

        const targetMsg = "You've subscribed to our newsletter! Check your inbox for 20% off your first purchase.";
        if (bodyEl && bodyEl.textContent.trim() !== targetMsg) {
          const heading = shadowRoot.querySelector('[class*="_textHeading_"]');
          if (heading) {
            heading.style.display = 'none';
          }
          bodyEl.textContent = targetMsg;
        }
      }
    });
    successObserver.observe(shadowRoot, {
      childList: true,
      subtree: true
    });

    // Run initial state setup
    updateState();
  }

  // Perform a full scan of the page for shadow roots
  function scanAndInject() {
    try {
      document.querySelectorAll('*').forEach(el => {
        try { if (el.shadowRoot) handleShadowRoot(el.shadowRoot); } catch (e) { }
      });
    } catch (e) { }
  }

  // Debounced scan scheduler to avoid performance overhead on multiple rapid mutations
  let scanTimeout = null;
  function scheduleScan() {
    if (scanTimeout) return;
    scanTimeout = setTimeout(() => {
      scanAndInject();
      scanTimeout = null;
    }, 150);
  }

  // Initial runs
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAndInject);
  } else {
    scanAndInject();
  }

  // Monitor DOM changes cleanly with debouncing
  const mainObserver = new MutationObserver(() => {
    scheduleScan();
  });
  mainObserver.observe(document.documentElement || document.body, { childList: true, subtree: true });

  // Retry checks for dynamic delayed shadow attachments
  let retryCount = 0;
  const retryInterval = setInterval(() => {
    scanAndInject();
    if (++retryCount >= 15) clearInterval(retryInterval);
  }, 1000);
})();